import React, { useEffect, useState } from "react";
import styles from "./License.module.css";
import { ServiceLogin } from "../../service/Login";
import i18n from "../../i18n";

export function License({perfil}) {

    const serviceLogin = new ServiceLogin();

    const [loading, setLoading] = useState(true);
    const [aviso, setAviso] = useState({ msg: "", type: "" });

    useEffect(() => {
        verficaLicence();
    }, []);

    async function verficaLicence() {
        const obj = {
            Familia: "1",
            Produto: "23"
        }

        try {
            const res = await serviceLogin.validaLicenca(obj);

            if (res) {
                const objRes = {
                    Success: res.Success,
                    Descricao: res.Descricao === null ? "" : res.Descricao !== "" ? res.Descricao : "",
                }

                if (objRes.Success && objRes.Descricao === "") {
                    return window.location = "#/portal";
                }

                if (objRes.Success && objRes.Descricao !== "") {
                    const msg = perfil === 'convênio' || perfil === 'medicoSolicitante' || perfil === 'paciente' ? "" : objRes.Descricao;
                    setAviso({ msg: msg, type: "success" });
                    setTimeout(() => {
                        return window.location = "#/portal";
                    }, 10000);
                }

                if (!objRes.Success && objRes.Descricao !== "") {
                    setLoading(false);
                    const msg = perfil === 'convênio' || perfil === 'medicoSolicitante' || perfil === 'paciente' ? i18n.t("PORTAL.COMPONENT.GENERIC_ADMIN_ERROR") : objRes.Descricao;
                    sessionStorage.removeItem('auth');
                    setAviso({ msg: msg, type: "error" });
                    return;
                }

                if (!objRes.Success && objRes.Descricao === "") {
                    setLoading(false);
                    const msg = perfil === 'convênio' || perfil === 'medicoSolicitante' || perfil === 'paciente' ? i18n.t("PORTAL.COMPONENT.GENERIC_ADMIN_ERROR") : objRes.Descricao;
                    sessionStorage.removeItem('auth');
                    setAviso({ msg: msg, type: "error" });
                    return;
                }

            }
        } catch (error) {
            console.log(error);
        }
    }

    function redirect() {
        window.location.reload();
        sessionStorage.removeItem('login');
    }

    return (
        <div className={styles.license}>
            <div className={styles.validaLicenca}>
                <h2 className={styles.titulo}>
                    {!perfil && i18n.t("PORTAL.COMPONENT.VALIDATING_LICENSE")}
                </h2>
                <p className={styles.paragrafoTxt}>
                    {!perfil && i18n.t("PORTAL.COMPONENT.LICENSE_VALIDATION")}
                </p>
                <>
                    <p className={styles.paragrafoDtLicence}>
                        {aviso.type === "error" ? (
                            <div className={styles.msgError}>
                                <p className={styles.paragrafoError}>{aviso.msg}</p>
                                <button onClick={() => redirect()}>{i18n.t("COMMON.BUTTON.OK")}</button>
                            </div>
                        ) : (
                            <p>{aviso.msg}</p>
                        )}
                    </p>
                    {loading && <progress value={null} className={styles.progressBar} />}
                </>
            </div>
        </div>
    )
}
